import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableAmpFragment = { readonly __typename?: 'SyncableAmp', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly vmpId: string, readonly productType: Types.ProductType, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncAmpPullQueryVariables = Types.Exact<{
  input: Types.PullAmpInput;
}>;


export type SyncAmpPullQuery = { readonly __typename?: 'Query', readonly pullAmp: { readonly __typename?: 'PullAmpResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableAmp', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly vmpId: string, readonly productType: Types.ProductType, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableAmpFragmentDoc = gql`
    fragment WholeSyncableAmp on SyncableAmp {
  id
  title
  keywords
  vmpId
  productType
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncAmpPullDocument = gql`
    query SyncAmpPull($input: PullAmpInput!) {
  pullAmp(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableAmp
    }
  }
}
    ${WholeSyncableAmpFragmentDoc}`;

/**
 * __useSyncAmpPullQuery__
 *
 * To run a query within a React component, call `useSyncAmpPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncAmpPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncAmpPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncAmpPullQuery(baseOptions: Apollo.QueryHookOptions<SyncAmpPullQuery, SyncAmpPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncAmpPullQuery, SyncAmpPullQueryVariables>(SyncAmpPullDocument, options);
      }
export function useSyncAmpPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncAmpPullQuery, SyncAmpPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncAmpPullQuery, SyncAmpPullQueryVariables>(SyncAmpPullDocument, options);
        }
export type SyncAmpPullQueryHookResult = ReturnType<typeof useSyncAmpPullQuery>;
export type SyncAmpPullLazyQueryHookResult = ReturnType<typeof useSyncAmpPullLazyQuery>;
export type SyncAmpPullQueryResult = Apollo.QueryResult<SyncAmpPullQuery, SyncAmpPullQueryVariables>;